module.exports = __webpack_public_path__ + "img/icon_audit_passed.1dc0a9e4.png";